export default __webpack_public_path__ + "static/media/md.c06d5bf9.jpg";